import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ec5f846"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-game-panel-content" }
const _hoisted_2 = {
  key: 0,
  class: "global-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "schedule-table"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }, "試合日程"),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }, "会場"),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }, "ホーム"),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }, "アウェイ"),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }, "本部"),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }, "審判"),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" }),
    /*#__PURE__*/_createElementVNode("th", { class: "schedule-table-th" })
  ])
], -1))
const _hoisted_5 = ["data-is-deleted"]
const _hoisted_6 = { class: "global-icon-button -draggable" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-draggabledots icon" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["data-disabled"]
const _hoisted_10 = ["onUpdate:modelValue", "disabled", "onInput", "onKeydown"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: undefined,
  disabled: ""
}, "ブロックを選択", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = ["onUpdate:modelValue", "disabled", "onKeydown"]
const _hoisted_14 = ["onUpdate:modelValue", "disabled", "onKeydown"]
const _hoisted_15 = ["data-disabled"]
const _hoisted_16 = ["onUpdate:modelValue", "disabled", "onKeydown"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "会場を選択", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = ["data-disabled"]
const _hoisted_20 = ["onUpdate:modelValue", "disabled", "onKeydown"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: undefined }, "ホームを選択", -1))
const _hoisted_22 = ["value", "disabled"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, " VS ", -1))
const _hoisted_24 = ["data-disabled"]
const _hoisted_25 = ["onUpdate:modelValue", "disabled", "onKeydown"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: undefined }, "アウェイを選択", -1))
const _hoisted_27 = ["value", "disabled"]
const _hoisted_28 = ["onUpdate:modelValue", "onKeydown"]
const _hoisted_29 = ["onUpdate:modelValue", "disabled", "onKeydown"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 詳細 ")
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 1,
  colspan: "2"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 4,
  class: "global-empty-text"
}
const _hoisted_37 = { class: "season-game-panel-footer _pcTabDisp" }
const _hoisted_38 = { class: "layout-inner -wide" }
const _hoisted_39 = { class: "season-game-panel-footer-container" }
const _hoisted_40 = { class: "add-row" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 日程を ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" 件 ")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-add-icon" }, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "buttonText" }, "追加", -1))
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = { class: "save-block" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-check-icon" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "変更を保存", -1))
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_CreateMatches = _resolveComponent("CreateMatches")!
  const _component_RequestGrouping = _resolveComponent("RequestGrouping")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.games.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : (_ctx.existGameList)
          ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_draggable, {
                tag: "tbody",
                class: "tbody",
                modelValue: _ctx.games.list,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.games.list) = $event)),
                handle: ".global-icon-button.-draggable",
                "item-key": "temporary_id"
              }, {
                item: _withCtx(({element, index}) => [
                  _createElementVNode("tr", {
                    ref: el => { if (el) _ctx.scheduleTableRows[index] = el },
                    "data-is-deleted": _ctx.gameIdsToBeDeleted.includes(element.id) ? true : false
                  }, [
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("button", _hoisted_6, _hoisted_8, 512), [
                        [_vShow, _ctx.$route.query.group == undefined]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        class: "global-select",
                        "data-disabled": _ctx.isMobile || element.id != undefined
                      }, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((element.group_id) = $event),
                          class: "js-form-element select -small",
                          "data-changed": "false",
                          disabled: _ctx.isMobile || element.id != undefined,
                          onInput: ($event: any) => {_ctx.changeGameElementColor; _ctx.resetGameTeam(index)},
                          onKeydown: ($event: any) => (_ctx.moveFocusScheduleElement($event, index))
                        }, [
                          _hoisted_11,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups.groupList, (group) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: group.id,
                              value: group.id
                            }, _toDisplayString(group.name), 9, _hoisted_12))
                          }), 128))
                        ], 40, _hoisted_10), [
                          [_vModelSelect, element.group_id]
                        ])
                      ], 8, _hoisted_9)
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "js-form-element global-input -small",
                        "onUpdate:modelValue": ($event: any) => ((element.match_no) = $event),
                        "data-changed": "false",
                        disabled: _ctx.isMobile,
                        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeGameElementColor && _ctx.changeGameElementColor(...args))),
                        onKeydown: ($event: any) => (_ctx.moveFocusScheduleElement($event, index))
                      }, null, 40, _hoisted_13), [
                        [_vModelText, element.match_no]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "js-form-element global-input -small",
                        "onUpdate:modelValue": ($event: any) => ((element.date) = $event),
                        "data-changed": "false",
                        disabled: _ctx.isMobile,
                        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeGameElementColor && _ctx.changeGameElementColor(...args))),
                        onKeydown: ($event: any) => (_ctx.moveFocusScheduleElement($event, index))
                      }, null, 40, _hoisted_14), [
                        [_vModelText, element.date]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        class: "global-select",
                        "data-disabled": _ctx.isMobile
                      }, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((element.field_id) = $event),
                          class: "js-form-element select -small",
                          "data-changed": "false",
                          disabled: _ctx.isMobile,
                          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeGameElementColor && _ctx.changeGameElementColor(...args))),
                          onKeydown: ($event: any) => (_ctx.moveFocusScheduleElement($event, index))
                        }, [
                          _hoisted_17,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields.list, (field) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: field.id,
                              value: field.id
                            }, _toDisplayString(field.name), 9, _hoisted_18))
                          }), 128))
                        ], 40, _hoisted_16), [
                          [_vModelSelect, element.field_id]
                        ])
                      ], 8, _hoisted_15)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        class: "global-select",
                        "data-disabled": _ctx.isMobile
                      }, [
                        _withDirectives(_createElementVNode("select", {
                          class: "js-form-element select -small",
                          "onUpdate:modelValue": ($event: any) => ((element.home_team_id) = $event),
                          "data-changed": "false",
                          disabled: _ctx.isMobile,
                          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeGameElementColor && _ctx.changeGameElementColor(...args))),
                          onKeydown: ($event: any) => (_ctx.moveFocusScheduleElement($event, index))
                        }, [
                          _hoisted_21,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries.list.filter((team) => team.group_id === element.group_id), (entry) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: entry.entry_team_id,
                              value: entry.entry_team_id,
                              disabled: entry.entry_team_id === element.away_team_id
                            }, _toDisplayString(entry.team_short_name) + " " + _toDisplayString(entry.division), 9, _hoisted_22))
                          }), 128))
                        ], 40, _hoisted_20), [
                          [_vModelSelect, element.home_team_id]
                        ])
                      ], 8, _hoisted_19)
                    ]),
                    _hoisted_23,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        class: "global-select",
                        "data-disabled": _ctx.isMobile
                      }, [
                        _withDirectives(_createElementVNode("select", {
                          class: "js-form-element select -small",
                          "onUpdate:modelValue": ($event: any) => ((element.away_team_id) = $event),
                          "data-changed": "false",
                          disabled: _ctx.isMobile,
                          onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeGameElementColor && _ctx.changeGameElementColor(...args))),
                          onKeydown: ($event: any) => (_ctx.moveFocusScheduleElement($event, index))
                        }, [
                          _hoisted_26,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries.list.filter((team) => team.group_id === element.group_id), (entry) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: entry.entry_team_id,
                              value: entry.entry_team_id,
                              disabled: entry.entry_team_id === element.home_team_id
                            }, _toDisplayString(entry.team_short_name) + " " + _toDisplayString(entry.division), 9, _hoisted_27))
                          }), 128))
                        ], 40, _hoisted_25), [
                          [_vModelSelect, element.away_team_id]
                        ])
                      ], 8, _hoisted_24)
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "js-form-element global-input -small",
                        "onUpdate:modelValue": ($event: any) => ((element.official) = $event),
                        "data-changed": "false",
                        onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeGameElementColor && _ctx.changeGameElementColor(...args))),
                        onKeydown: ($event: any) => (_ctx.moveFocusScheduleElement($event, index))
                      }, null, 40, _hoisted_28), [
                        [_vModelText, element.official]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "js-form-element global-input -small",
                        "onUpdate:modelValue": ($event: any) => ((element.refree) = $event),
                        "data-changed": "false",
                        disabled: _ctx.isMobile,
                        onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changeGameElementColor && _ctx.changeGameElementColor(...args))),
                        onKeydown: ($event: any) => (_ctx.moveFocusScheduleElement($event, index))
                      }, null, 40, _hoisted_29), [
                        [_vModelText, element.refree]
                      ])
                    ]),
                    (!_ctx.gameIdsToBeDeleted.includes(element.id))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("td", null, [
                            (element.id != undefined)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  class: "schedule-detail-button",
                                  to: {
                    name: 'seasonGameDetail',
                    params: { topic_id: _ctx.$route.params.topic_id, seson_id: _ctx.$route.params.season_id, game_id: element.id },
                    query: { group: element.group_id } }
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_30
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "global-delete-button",
                              onClick: ($event: any) => (_ctx.judgeDeleteGame(element, index))
                            }, _hoisted_33, 8, _hoisted_31)
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("td", _hoisted_34, [
                          (element.id)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "schedule-undo-button",
                                onClick: ($event: any) => (_ctx.restoreDeletedGame(element))
                              }, " 元に戻す ", 8, _hoisted_35))
                            : _createCommentVNode("", true)
                        ]))
                  ], 8, _hoisted_5)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : (_ctx.$route.query.group != undefined && _ctx.existEntryTeams)
            ? (_openBlock(), _createBlock(_component_CreateMatches, {
                key: 2,
                name: _ctx.matchType === 'league' ? '対戦試合' : 'トーナメント',
                onOnClickCreateButton: _ctx.onClickCreateButton
              }, null, 8, ["name", "onOnClickCreateButton"]))
            : (_ctx.$route.query.group != undefined)
              ? (_openBlock(), _createBlock(_component_RequestGrouping, {
                  key: 3,
                  name: _ctx.matchType === 'league' ? '対戦試合' : 'トーナメント'
                }, null, 8, ["name"]))
              : (_openBlock(), _createElementBlock("p", _hoisted_36, "登録されている試合がありません"))
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _withDirectives(_createElementVNode("input", {
              class: "global-input -small",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.games.scheduleAddNumber) = $event))
            }, null, 512), [
              [_vModelText, _ctx.games.scheduleAddNumber]
            ]),
            _hoisted_42,
            _createElementVNode("button", {
              type: "button",
              class: "button",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addScheduleRow && _ctx.addScheduleRow(...args)))
            }, _hoisted_45)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("button", {
              type: "button",
              class: "global-button",
              disabled: !_ctx.existGameList,
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onClickSaveGames && _ctx.onClickSaveGames(...args)))
            }, _hoisted_50, 8, _hoisted_47)
          ])
        ])
      ])
    ]),
    (_ctx.gamesDialogConfirm.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 0,
          dialog: _ctx.gamesDialogConfirm,
          onCloseDialog: _ctx.closeGamesDialogConfirm,
          onOnConfirm: _ctx.saveGames
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true)
  ], 64))
}